import { getField } from "vuex-map-fields";
import { i18n } from "packs/user/i18n";
import { isEmpty, reject, orderBy, map, filter, isArray, has } from "lodash-es";

export default {
  getField,
  reservationPax(state) {
    const adult = state.reservation.adult != "" ? state.reservation.adult : 0;
    const kids = state.reservation.kids != "" ? state.reservation.kids : 0;
    return parseInt(adult) + parseInt(kids);
  },

  paxPreference(state, getters) {
    const adult = state.reservation.adult != "" ? state.reservation.adult : 0;
    const kids = state.reservation.kids != "" ? state.reservation.kids : 0;
    if (adult > 0 && state.userDineInMethod === "dine in") {
      if (kids > 0) {
        return `${getters.reservationPax} ${i18n.t(
          "package.pax"
        )} (${adult}A, ${kids}K)`;
      }
      return `${getters.reservationPax} ${i18n.t("package.pax")}`;
    }
    return "";
  },
  restaurantAttr(state) {
    if (isEmpty(state.restaurant)) {
      return false;
    }
    return state.restaurant.attributes;
  },
  restaurantRecordGuest(state, getters) {
    if (getters.restaurantAttr) {
      if (
        getters.restaurantAttr.recordGuests == true &&
        state.userDineInMethod === "dine in"
      ) {
        return true;
      }
      return false;
    }
    return false;
  },
  hasHungryAtHomePackageOnly(state, getters) {
    if (getters.restaurantAttr) {
      if (
        !getters.restaurantAttr.lowestAycePrice &&
        !getters.restaurantAttr.lowestPpPrice &&
        !getters.restaurantAttr.lowestHsPrice &&
        !getters.restaurantAttr.lowestBfpPrice &&
        !getters.restaurantAttr.lowestSmPrice &&
        getters.restaurantAttr.lowestHahPrice !== null
      ) {
        return true;
      }
      return false;
    }
    return false;
  },
  restaurantReservationSystemOnly(state, getters) {
    if (getters.restaurantAttr) {
      return getters.restaurantAttr.reservationSystemOnly || false;
    }
    return false;
  },
  bookingPreference(state, getters) {
    const pax = getters.paxPreference;
    const date = state.reservation.formatedDate
      ? state.reservation.formatedDate
      : "";
    const startTime = !isEmpty(state.reservation.startTime)
      ? state.reservation.startTime
      : "";
    const selectedPackage = !isEmpty(state.reservation.selectedPackages)
      ? getters.selectedPackagesDescription
      : "";

    const paxSpan = pax !== "" ? `<span class="br pr2">${pax}</span>` : "";
    const dateSpan = date !== "" ? `<span class="pl2 pr2">${date}</span>` : "";
    const startTimeSpan =
      startTime !== "" ? `<span class="bl pl2 pr2">${startTime}</span>` : "";
    const selectedPackageSpan =
      selectedPackage !== ""
        ? `<span class="bl pl2">${selectedPackage}</span>`
        : "";
    return paxSpan + dateSpan + startTimeSpan + selectedPackageSpan;
  },
  isPartialCharge(state, getters) {
    const packageDetail = getters.selectedPackagesDetail.attributes
      ? getters.selectedPackagesDetail.attributes
      : getters.selectedPackagesDetail;

    if (isEmpty(packageDetail)) {
      return false;
    } else {
      const packagePartialCharge = filter(packageDetail, pack => {
        const chargeAmountObj = pack.attributes
          ? pack.attributes.chargeAmount
          : pack.chargeAmount;
        if (
          chargeAmountObj.amount &&
          chargeAmountObj.type &&
          chargeAmountObj.formula
        ) {
          return true;
        }
        return false;
      });
      if (packagePartialCharge.length > 0) {
        return true;
      }
      return false;
    }
  },
  isDineIn(state, getters) {
    const packageDetail = getters.selectedPackagesDetail.attributes
      ? getters.selectedPackagesDetail.attributes
      : getters.selectedPackagesDetail;

    if (getters.restaurantReservationSystemOnly) {
      return true;
    } else if (isEmpty(packageDetail)) {
      return false;
    } else {
      const forDineIn = filter(packageDetail, pack => {
        if (has(pack, "attributes")) {
          return pack.attributes.forDineIn === true;
        }
        return pack.forDineIn === true;
      });
      if (forDineIn.length > 0) {
        return true;
      }
      return false;
    }
  },
  isRequireCc: (_, getters) => {
    const packageDetail = getters.selectedPackagesDetail.attributes
      ? getters.selectedPackagesDetail.attributes
      : getters.selectedPackagesDetail;

    if (isEmpty(packageDetail)) {
      return false;
    } else {
      const packageRequireCc = filter(packageDetail, pack => {
        if (has(pack, "attributes")) {
          return pack.attributes.requireCc === true;
        }
        return pack.requireCc === true;
      });
      if (packageRequireCc.length > 0) {
        return true;
      }
      return false;
    }
  },
  allCcFieldValid(state, getters) {
    if (getters.isRequireCc) {
      if (
        state.cc.name &&
        state.cc.number &&
        state.cc.expirationMonth &&
        state.cc.expirationYear &&
        state.cc.securityCode
      ) {
        return true;
      }
      return false;
    }
    return true;
  },
  selectedPackagesDetail(state) {
    const ids = map(state.reservation.selectedPackages, "id");
    return reject(state.allPackages, p => {
      return !ids.includes(p.id);
    });
  },
  selectedPackagePaymentType(state, getters) {
    const packageDetail = getters.selectedPackagesDetail;
    let qrPayment = [];
    let ccPayment = [];
    let bothPayment = [];
    if (packageDetail.length > 0) {
      packageDetail.forEach(packages => {
        if (packages.hasOwnProperty("paymentType")) {
          if (packages.paymentType == "qrcode_and_creditcard") {
            bothPayment.push(true);
          } else if (packages.paymentType == "qrcode") {
            qrPayment.push(true);
          } else if (packages.paymentType == "creditcard") {
            ccPayment.push(true);
          }
        }
      });
      // determine payment
      if (bothPayment.length > 0) {
        return "qrcode_and_creditcard";
      } else if (ccPayment.length > 0 && qrPayment.length > 0) {
        return "qrcode_and_creditcard";
      } else if (ccPayment.length > 0) {
        return "creditcard";
      } else if (qrPayment.length > 0) {
        return "qrcode";
      }
    }
    return "";
  },
  selectedPackageDeliveryType(state, getters) {
    const packageDetail = getters.selectedPackagesDetail;
    let delivery = [];
    let pickup = [];
    let bothPickupAndDelivery = [];
    if (packageDetail.length > 0) {
      packageDetail.forEach(packages => {
        if (packages.hasOwnProperty("availableMethods")) {
          if (packages.availableMethods == "self_pickup_and_delivery") {
            bothPickupAndDelivery.push(true);
          } else if (packages.availableMethods == "delivery") {
            delivery.push(true);
          } else if (packages.availableMethods == "self_pickup") {
            pickup.push(true);
          }
        }
      });
      // determine delivery type
      if (bothPickupAndDelivery.length > 0) {
        return "self_pickup_and_delivery";
      } else if (delivery.length > 0 && pickup.length > 0) {
        return "self_pickup_and_delivery";
      } else if (delivery.length > 0) {
        return "delivery";
      } else if (pickup.length > 0) {
        return "self_pickup";
      } else {
        return "self_pickup_and_delivery";
      }
    }
    return "";
  },
  bookingPrice(state, getters) {
    const totalPerson = state.reservation.adult;
    if (getters.selectedPackagesDetail.length == 1) {
      let packagePrice;
      if (isArray(getters.selectedPackagesDetail[0].pricing)) {
        packagePrice = filter(
          getters.selectedPackagesDetail[0].pricing,
          price => {
            return totalPerson >= price.minSeat && totalPerson <= price.maxSeat;
          }
        )[0];
      } else {
        packagePrice = getters.selectedPackagesDetail[0].pricing;
      }
      return (
        packagePrice.priceInt * state.reservation.adult +
        (packagePrice.priceInt *
          state.reservation.kids *
          packagePrice.kidsPriceRate) /
          100.0
      );
    } else {
      let total = 0;
      getters.selectedPackagesDetail.forEach((packages, index) => {
        total +=
          packages.pricing.priceInt *
          state.reservation.selectedPackages[index].quantity;
      });
      return total;
    }
  },
  selectedPackageAcceptManyQuantity(state, getters) {
    if (getters.selectedPackagesDetail.length > 0) {
      const packages = getters.selectedPackagesDetail[0];
      if (packages.isAcceptManyQuantity) {
        return true;
      }
      return false;
    }
  },
  selectedPackagesDescription(state, getters) {
    const totalPerson = state.reservation.adult;
    if (getters.selectedPackagesDetail.length > 0) {
      // use for package that have attributes isAcceptManyQuantity (eg: party pack, hungry lunch, hungry at home)
      if (getters.selectedPackagesDetail[0].isAcceptManyQuantity) {
        let description = "";
        getters.selectedPackagesDetail.forEach((packages, index) => {
          const selectedPackages = state.reservation.selectedPackages.filter(
            selectedPackages => {
              return selectedPackages.id === packages.id;
            }
          );
          // add delimter
          if (index > 0) {
            description += ", ";
          }
          description += `${packages.name} (${packages.pricing.price} X ${selectedPackages[0].quantity})`;
        });
        return description;
      } else {
        let packagePrice;
        // some packages have array pricing
        if (isArray(getters.selectedPackagesDetail[0].pricing)) {
          packagePrice = filter(
            getters.selectedPackagesDetail[0].pricing,
            price => {
              return (
                totalPerson >= price.minSeat && totalPerson <= price.maxSeat
              );
            }
          )[0];
        } else {
          packagePrice = getters.selectedPackagesDetail[0].pricing;
        }
        return `${map(getters.selectedPackagesDetail, "name")} ${
          packagePrice.price
        }`;
      }
    }
  },
  takeAwayProperty(state, getters) {
    if (getters.selectedPackagesDetail.length > 0) {
      return getters.selectedPackagesDetail[0].takeAwayProperty;
    } else {
      return "";
    }
  },
  isShowDeliveryFee(state, getters) {
    if (
      getters.takeAwayProperty == false ||
      state.reservation.partialCharge == false
    ) {
      return false;
    } else {
      const bookingPrice = state.reservation.partialCharge.totalPrice;
      const freeDeliveryFeeThreshold = parseInt(
        getters.takeAwayProperty.freeDeliveryFeeThreshold
      );
      const isFreeDelivery =
        bookingPrice < freeDeliveryFeeThreshold ? true : false;
      if (
        getters.isDineIn === false &&
        state.reservation.occasion === "delivery" &&
        isFreeDelivery === false
      ) {
        return true;
      }
      return false;
    }
  },
  deliveryFee(state, getters) {
    if (getters.takeAwayProperty) {
      return getters.takeAwayProperty.deliveryFfee;
    }
    return 0;
  },
  linkTNC(state, getters) {
    if (isEmpty(getters.selectedPackagesDetail)) {
      return "";
    } else {
      const tncLink = getters.selectedPackagesDetail[0].packageInfo.tncLink;
      return tncLink;
    }
  }
};
